/* import __COLOCATED_TEMPLATE__ from './buyer-feedback-details.hbs'; */
import { computed } from '@ember/object';
import { A } from '@ember/array';
import Component from '@ember/component';

const ABOUT_RIGHT = 'about_right';
const TOO_MANY = 'too_many';
const TOO_FEW = 'too_few';

const MOST = 'most';
const SOME = 'some';
const NOT_REALLY = 'not_really';

const tuple = (value, name) => ({ name, value });

const APPLICANT_NUMBER_TUPLES = [
  tuple(ABOUT_RIGHT, 'About right'),
  tuple(TOO_MANY, 'Too many'),
  tuple(TOO_FEW, 'Too few'),
];

const MOST_SOME_NOT_REALLY_TUPLES = [
  tuple(MOST, 'Most'),
  tuple(SOME, 'Some'),
  tuple(NOT_REALLY, 'Not really'),
];

export default Component.extend({
  /** @inheritDoc */
  tagName: 'aside',

  /** @inheritDoc */
  classNames: ['buyer-feedback'],

  /** @type {Ember.A<Object>} */
  numberOfApplicants: A(APPLICANT_NUMBER_TUPLES),

  /** @type {Ember.A<Object>} */
  applicantsInRightLocation: A(MOST_SOME_NOT_REALLY_TUPLES),

  /** @type {Ember.A<Object>} */
  applicantsAreQualified: A(MOST_SOME_NOT_REALLY_TUPLES),

  /** @type {string} */
  numberOfApplicantsSelected: undefined,

  /** @type {string} */
  applicantsInRightLocationSelected: undefined,

  /** @type {string} */
  applicantsAreQualifiedSelected: undefined,

  /** @param {string} */
  overall: undefined,

  /** @param {function} */
  onFormSubmit: undefined,

  /** @type {string} */
  optionalFeedback: '',

  /** @type {boolean} */
  formDisabled: computed('numberOfApplicantsSelected', 'applicantsInRightLocationSelected', 'applicantsAreQualifiedSelected', 'formSubmitting', function() {
    if (!this.get('numberOfApplicantsSelected')) return true;
    if (!this.get('applicantsInRightLocationSelected')) return true;
    if (!this.get('applicantsAreQualifiedSelected')) return true;

    return false;
  }),

  /** @inheritDoc */
  actions: {

    /**
     *
     */
    submitForm() {
      const overall = this.get('overall');
      const applicants_number = this.get('numberOfApplicantsSelected');
      const applicants_location = this.get('applicantsInRightLocationSelected');
      const applicants_qualified = this.get('applicantsAreQualifiedSelected');
      const comment = this.get('optionalFeedback');

      const args = {
        overall,
        applicants_number,
        applicants_location,
        applicants_qualified,
      };

      if (comment) {
        args.comment = comment;
      }

      this.onFormSubmit(args);
    },
  },
});
